import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../../utils";
const Table = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("div", {
        className: "relative w-full overflow-auto",
        children: /*#__PURE__*/ _jsx("table", {
            ref: ref,
            className: cn("w-full caption-bottom text-sm", className),
            ...props
        })
    }));
Table.displayName = "Table";
const TableHeader = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("thead", {
        ref: ref,
        className: cn("[&_tr]:border-b", className),
        ...props
    }));
TableHeader.displayName = "TableHeader";
const TableBody = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("tbody", {
        ref: ref,
        className: cn("[&_tr:last-child]:border-0", className),
        ...props
    }));
TableBody.displayName = "TableBody";
const TableFooter = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("tfoot", {
        ref: ref,
        className: cn("border-t bg-muted/50 font-medium [&>tr]:last:border-b-0", className),
        ...props
    }));
TableFooter.displayName = "TableFooter";
const TableRow = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("tr", {
        ref: ref,
        className: cn("group border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted", className),
        ...props
    }));
TableRow.displayName = "TableRow";
const TableHead = /*#__PURE__*/ React.forwardRef(({ className, sticky, ...props }, ref)=>/*#__PURE__*/ _jsx("th", {
        ref: ref,
        className: cn("h-12 px-4 text-left align-middle font-medium text-black bg-muted text-sm [&:has([role=checkbox])]:pr-0", sticky && "sticky z-10", sticky === "left" && "left-0", sticky === "right" && "right-0", className),
        ...props
    }));
TableHead.displayName = "TableHead";
const TableCell = /*#__PURE__*/ React.forwardRef(({ className, sticky, ...props }, ref)=>/*#__PURE__*/ _jsx("td", {
        ref: ref,
        className: cn("p-4 align-middle [&:has([role=checkbox])]:pr-0", sticky && "sticky z-10 bg-background group-hover:bg-muted/50 transition-colors", sticky === "left" && "left-0", sticky === "right" && "right-0 text-right", className),
        ...props
    }));
TableCell.displayName = "TableCell";
const TableCaption = /*#__PURE__*/ React.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ _jsx("caption", {
        ref: ref,
        className: cn("mt-4 text-sm text-muted-foreground", className),
        ...props
    }));
TableCaption.displayName = "TableCaption";
export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };

//# sourceMappingURL=table.js.map